import React, { useState } from 'react';

export default function CreateListForm({ onCreateList, onCancel }) {
  const [listName, setListName] = useState('');
  const [isCreating, setIsCreating] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!listName.trim()) return;

    setIsCreating(true);
    try {
      await onCreateList(listName.trim());
      setListName('');
    } catch (error) {
      console.error('Error creating list:', error);
    } finally {
      setIsCreating(false);
    }
  };

  const handleCancel = () => {
    setListName('');
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className="create-list-form-card">
      <div className="form-header">
        <h3 className="form-header-title">Create New List</h3>
      </div>
      <div className="form-body">
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={listName}
            onChange={(e) => setListName(e.target.value)}
            placeholder="Enter list name..."
            className="input-custom"
            style={{ marginBottom: '1rem', width: '100%' }}
            disabled={isCreating}
            autoFocus
            aria-label="New list name"
          />
          <div className="create-list-hints">
            <div className="hint-item">
              <span className="hint-text">
                <strong>Pro tip:</strong> Create a list named "Daily Habits" to track recurring tasks with completion history
              </span>
            </div>
          </div>
          <div className="form-actions">
            <button
              type="submit"
              disabled={isCreating || !listName.trim()}
              className="btn-custom btn-primary-custom"
              style={{ flex: 1 }}
            >
              {isCreating ? 'Creating...' : 'Create List'}
            </button>
            <button
              type="button"
              onClick={handleCancel}
              disabled={isCreating}
              className="btn-custom btn-secondary-custom"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
